export function cx(...classNames: (string | Falsy)[]) {
  return classNames.filter(Boolean).join(' ');
}

type Falsy = false | null | undefined | 0 | '';
